module.exports = __webpack_public_path__ + "assets/manual_mychoice-93cf6d70e291210df56f5d4909a8b3c8.pdf";